import React, { FC, useState } from 'react'
import { CollectionRecord } from 'collectionData'
import useApiCall from 'hooks/useApiCall/useApiCall'

import { getCollectionData } from '../../api/rest/collectionRequest'

const defaultYear = 2015

const CollectionYearContext = React.createContext(defaultYear)

export const CollectionYearProvider: FC = ({ children }) => {
    const [year, setYear] = useState<number>()

    const handleResponse = (data: CollectionRecord[]) => {
        const fetchedYear = Math.max(
            ...data.map((entry) => entry?.year || defaultYear)
        )

        setYear(fetchedYear)
    }

    const [{ loading }] = useApiCall(getCollectionData, handleResponse)

    if (!loading) {
        return (
            <CollectionYearContext.Provider value={year || defaultYear}>
                {children}
            </CollectionYearContext.Provider>
        )
    }

    return null
}

export default CollectionYearContext
